import React, { useEffect, useState } from 'react'
import { Modal, Form, Input, Typography, Statistic, Result, Row, Button, Popconfirm } from 'antd';
import '../index.less';

const { Text } = Typography;
const { Search } = Input;

const formItemLayout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 12
  },
};

let scanTimer = null;
let countTimer = null
const ScanCodePayment = (props) => {

  const { visible, onCancel, loading, dispatch, merchantCode, paymentReturnInfo, paymentStatus, queryPaymentStatus, form, info, location: { query }, onCancelPayment } = props;
  const { getFieldDecorator, validateFields, setFieldsValue } = form;

  const [time,setTime] = useState(3);


  useEffect(() => {
    if(visible){
      // console.log('监听')
      let code = '';
      let lastTime, nextTime;
      let lastCode, nextCode;
      document.onkeypress = (e) => {
        if (window.event) { // IE
          // console.log(1, e);
          nextCode = e.keyCode;
        } else if (e.which) { // Netscape/Firefox/Opera
          // console.log(2, e);
          nextCode = e.which;
        }
  
        if (nextCode === 13) {
          if (code.length < 3) return; // 手动输入的时间不会让code的长度大于2，所以这里只会对扫码枪有
  
          // console.log('code', code); // 获取到扫码枪输入的内容，做别的操作
          setFieldsValue({'code':code})
          code = '';
          lastCode = '';
          lastTime = '';
          return;
        }
        nextTime = new Date().getTime();
        if (!lastTime && !lastCode) {
          code += e.key;
        }
  
        if (lastCode && lastTime && nextTime - lastTime > 30) { // 当扫码前有keypress事件时,防止首字缺失
          code = e.key;
        } else if (lastCode && lastTime) {
          code += e.key;
        }
        lastCode = nextCode;
        lastTime = nextTime;
        // console.log('ccc',code)
      }
    }

    return ()=>{
      if(scanTimer){
        clearInterval(scanTimer);
      }
      if(countTimer){
        clearInterval(countTimer)
      }
    }
  }, [visible])

  const handleOk = (value) => {
    validateFields((errors, values) => {
      if (errors) {
        return
      }
      let params = {
        amount:paymentReturnInfo&&paymentReturnInfo.amount&&paymentReturnInfo.amount*100||0,
        paymentOrderCode:paymentReturnInfo&&paymentReturnInfo.fakeOrderCode,
        merchantCode:merchantCode,
        authCode:value,
      }
      dispatch({type:'orderList/updateState',payload:{queryPaymentStatus:true}})
      dispatch({type:'orderList/onlinePayment',payload:params}).then((res)=>{
        if(res&&res.status === '2'){
          setTimeout(() => {
            dispatch({ type: 'orderList/queryOrderUpgradeList', payload: {orderId: info.id}})
            dispatch({type: 'orderList/query', payload: {...query}})
            dispatch({ type: 'orderList/queryPayments', payload: { orderId: info.id, pageNo: 1 } })
            dispatch({type:'orderList/updateState',payload:{scanCodePaymentVisible:false,receivablesVisible:false,queryPaymentStatus:false,paymentBtnDisabled:false,paymentReturnInfo:{},merchantCode:'',paymentStatus:'pending'}});
            clearInterval(countTimer);
          }, 3000);
          countTimer = setInterval(() => {
            setTime((t)=>{return t - 1})
          }, 1000);
        }else if(res&&res.status === '8'){

        }else if(res&&res.status === '0'){
          let params = {
            merchantCode:res.merchant_id,
            paymentOrderId:res.third_order_id
          }
          scanTimer = setInterval(() => {
            dispatch({type:'orderList/queryResult',payload:params}).then((response)=>{
              if(response&&response.status === '2'){
                dispatch({ type: 'orderList/queryOrderDetail', payload: info.id })
                dispatch({ type: 'orderList/queryOrderUpgradeList', payload: {orderId: info.id}})
                dispatch({type: 'orderList/query', payload: {...query}})
                dispatch({ type: 'orderList/queryPayments', payload: { orderId: info.id, pageNo: 1 } })
                clearInterval(scanTimer);
                setTimeout(() => {
                  clearInterval(countTimer);
                  dispatch({type:'orderList/updateState',payload:{scanCodePaymentVisible:false,receivablesVisible:false,queryPaymentStatus:false,paymentBtnDisabled:false,paymentReturnInfo:{},merchantCode:'',paymentStatus:'pending'}});
                }, 3000);
                countTimer = setInterval(() => {
                  setTime((t)=>{return t - 1})
                }, 1000);
              }else if(response&&response.status === '8'){
                clearInterval(scanTimer);
              }else if(response&&response.status === '0'){

              }
            })
          }, 3000);
        }
      })
    })
  }

  return (
    <Modal
      title='收银台'
      visible={visible}
      footer={null}
      onCancel={() => { onCancel && onCancel() }}
      // style={{zIndex:1005}}
      maskStyle={{ zIndex: 1004 }}
      maskClosable={false}
      wrapClassName='scan-payment-modal-wrap'
      destroyOnClose
      width={800}
    >
      {paymentStatus === 'pending'&&
      <>
        <Row style={{ textAlign: 'center' }}>
          <Statistic valueStyle={{ color: '#D42020' }} value={paymentReturnInfo&&paymentReturnInfo.amount} prefix={<span style={{color:'#D42020'}}>金额：</span>} suffix="元" />
        </Row>
        <div className='payment-content'>
          <div className='payment-head'>付款码支付</div>
          <div className='payment-body'>
            <Form {...formItemLayout} style={{ marginTop: 24 }}>
              <Form.Item label='支付码'>
                {getFieldDecorator('code', {
                  rules: [
                    {
                      required: true,
                      message: '支付码必填',
                    },
                  ]
                })(<Search autoFocus enterButton='支付' onSearch={value => handleOk(value)} loading={queryPaymentStatus} />)}
              </Form.Item>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div>
                  <Text type="danger">温馨提示 : </Text>
                </div>
                <div>
                  <Text type="danger"> 请确认支付盒子连接成功且是启用状态</Text><br />
                  <Text type="danger"> 请让客户将手机付款码放入盒子区域</Text><br />
                  <Text type="danger"> 支持微信、支付宝、云闪付付款码支付</Text>
                </div>
              </div>
            </Form>
          </div>
          <Popconfirm
                title="确认取消此次支付吗?"
                onConfirm={()=>{onCancelPayment&&onCancelPayment(paymentReturnInfo,true)}}
                okText="是"
                cancelText="否"
              >
            <Button type='primary' style={{marginTop:20}}>取消扫码</Button>
          </Popconfirm>
        </div>
      </>
      }
      {paymentStatus === 'success'&&
         <Result
         status="success"
         title="支付成功!"
         subTitle={`${time}s后自动关闭当前窗口`}
       />
      }
      {paymentStatus === 'error'&&
         <Result
         status="error"
         title="支付失败!"
         subTitle="请重新新增收款！"
       />
      }
    </Modal>
  )
}


export default Form.create()(ScanCodePayment)